export default "__VITE_ASSET__CWJeAI3K__"